import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/report/`;

const getAmountSummaryReport = async (formData) => {
  return await axios.post(API_URL + "amountsummary", formData);
};

const getExpenseSummaryReport = async () => {
  return await axios.get(API_URL + "expensesummary");
};

const getWeightSummaryReport = async (formData) => {
  return await axios.post(API_URL + "weightsummary",formData);
};

const getMoneyExchangeSummaryReport = async () => {
  return await axios.get(API_URL + "moneyexchangesummary");
};

const getProfitSummaryReport = async () => {
  return await axios.get(API_URL + "profitsummary");
};

const getNewCustomerPerformanceReport = async (formData) => {
  return await axios.post(API_URL + "newcustomer", formData);
};

const getRegisMonthAmountReport = async (formData) => {
  return await axios.post(API_URL + "regismonth",formData);
};

const getRegisMonthAmountDetail = async (formData) => {
  return await axios.post(API_URL + "regismonth/detail", formData);
};

const getReceiptAmountReport = async (period) => {
  return await axios.post(API_URL + "receiptsummary", {period});
};

const getMonthlyProfitReport = async (shop) => {
  return await axios.post(API_URL + "newprofit", shop);
};

const getUnpaidDetailReport = async (formData) => {
  return await axios.post(API_URL + "unpaiddetail", formData);
};

const getCustomerPendingPaymentsReportByShipDate = async (formData) => {
  return await axios.post(API_URL + "customerpendingpayments", formData);
};

const getCompanyCustomerSummaryReport = async (body = {}) => {
  return await axios.post(API_URL + "companycustomersummary", body);
};

const getCustomerProfitSummaryReport = async (limit = 100) => {
  return await axios.get(API_URL + `customerprofitsummary?limit=${limit}`);
};

const getDividendDashboard = async () => {
  return await axios.get(API_URL + 'dividend-dashboard');
};

const getOrdererPayments = async () => {
  return await axios.get(API_URL + 'orderer-payments');
};

const getOrderers = async () => {
  return await axios.get(API_URL + 'orderer-payments/orderers');
};

const createOrdererPayment = async (body) => {
  return await axios.post(API_URL + 'orderer-payments', body);
};

const deleteOrdererPayment = async (id) => {
  return await axios.delete(API_URL + `orderer-payments/${id}`);
};

const getExpenseComparison = async () => {
  return await axios.get(API_URL + 'expense-comparison');
};

const saveJapanBalanceSnapshot = async (body) => {
  return await axios.post(API_URL + 'japan-balance', body);
};

const deleteJapanBalanceSnapshot = async (id) => {
  return await axios.delete(API_URL + `japan-balance/${id}`);
};

export default {

  getAmountSummaryReport,
  getExpenseSummaryReport,
  getWeightSummaryReport,
  getMoneyExchangeSummaryReport,
  getProfitSummaryReport,
  getNewCustomerPerformanceReport,
  getRegisMonthAmountReport,
  getReceiptAmountReport,
  getRegisMonthAmountDetail,
  getUnpaidDetailReport,
  getMonthlyProfitReport,
  getCustomerPendingPaymentsReportByShipDate,
  getCompanyCustomerSummaryReport,
  getCustomerProfitSummaryReport,
  getDividendDashboard,
  saveJapanBalanceSnapshot,
  deleteJapanBalanceSnapshot,
  getOrdererPayments,
  getOrderers,
  createOrdererPayment,
  deleteOrdererPayment,
  getExpenseComparison,
};
